declare var Modernizr: {
  touchevents: boolean,
};

const $starSelector = $('.js-star-selector');

const STATE_FULL = 'state-full';
const STATE_HALF = 'state-half';
const STATE_EMPTY = 'state-empty';

const STYLE_SELECTED = 'style-selected';
const STYLE_SELECTING = 'style-selecting';

const starSelector = {
  initialize(starSelectorElement: HTMLElement) {
    this.$element = $(starSelectorElement);
    this.$stars = this.$element.find('.js-star-selector-star');
    this.$mark = this.$element.find('.js-star-selector-mark');
    this.$input = this.$element.find('.js-star-selector-input');

    this.ignoreEvents = false;
    this.lastStarScore = -1;
    this.lastStyle = '';

    this.score = parseFloat(this.$element.data('default'));

    this.createListeners();
    this.outputScore(this.score);
  },

  createListeners() {
    this.$element.on('mouseleave', () => {
      this.setStyle(STYLE_SELECTED);
      this.resetToDefault();
    });

    if (!Modernizr.touchevents) {
      this.$element.on('mousemove', '.js-star-selector-star', (e: any) => {
        if (this.ignoreEvents) {
          return;
        }

        let index = this.getScoreForButton(e);

        if (index < 1) {
          index = 1;
        }

        this.setStyle(STYLE_SELECTING);
        this.outputScore(index);
      });
    }

    this.$element.on('click', '.js-star-selector-star', (e: any) => {
      this.score = this.getScoreForButton(e);

      if (this.score < 1) {
        this.score = 1;
      }

      this.ignoreEvents = true;

      setTimeout(
        () => {
          this.ignoreEvents = false;
        },
        1000,
      );

      this.setStyle(STYLE_SELECTED);
      this.resetToDefault();
    });
  },

  /**
   * Return the score for a clicked button
   * @param {Object} e
   * @return {number}
   */
  getScoreForButton(e: any): number {
    let index = $(e.currentTarget).index() + 1;
    const positionOnButton = this.getPositionOnButton(e);

    if (positionOnButton >= 0 && positionOnButton < 0.5) {
      index = index - 0.5;
    }

    return index;
  },

  /**
   * Retrieve the X position of the mouse on a star, it will return a number between
   * 0 and 1
   * @param {Object} e
   * @return {number}
   */
  getPositionOnButton(e: any): number {
    const mouseX = e.pageX;
    const starX = $(e.currentTarget).offset().left;
    const x = mouseX - starX;
    const starWidth = $(e.currentTarget).width();

    return x / starWidth;
  },

  /**
   * Helper method to return the star selector to the selected score (or default)
   * @return {void}
   */
  resetToDefault(): void {
    this.outputScore(this.score);
  },

  /**
   * Set stars style
   * @param {string} style
   * @return {void}
   */
  setStyle(style: string) {
    if (style === this.lastStyle) {
      return;
    }

    this.lastStyle = style;

    this.$element.removeClass(`${STYLE_SELECTED} ${STYLE_SELECTING}`);
    this.$element.addClass(style);
  },

  /**
   * Output score to the DOM
   * @param {number} starScore
   * @return {void}
   */
  outputScore(starScore: number): void {
    // Prevent useless DOM manipulations when the score hasn't changed
    if (starScore === this.lastStarScore) {
      return;
    }

    this.lastStarScore = starScore;

    this.$stars.toArray().forEach((star: HTMLElement, index: number) => {
      const $star = $(star);
      $star.removeClass(`${STATE_FULL} ${STATE_HALF} ${STATE_EMPTY}`);

      if (starScore - index === 0.5) {
        $star.addClass(STATE_HALF);
      } else if (starScore - index > 0) {
        $star.addClass(STATE_FULL);
      } else {
        $star.addClass(STATE_EMPTY);
      }
    });

    this.$mark.text(starScore.toString().replace('.', ','));

    this.$input.val(starScore);

    if (typeof this.$input.parsley === 'function' && this.hasAlreadyBeenValidated()) {
      this.$input.parsley().validate();
    }
  },

  hasAlreadyBeenValidated() {
    return this.$input.parents('.parsley-error').length > 0;
  },
};

export default {
  initialize() {
    if (!$starSelector.length) {
      return;
    }

    $starSelector.toArray().forEach((starSelectorElement) => {
      const starSelectorInstance = Object.assign({}, starSelector);
      starSelectorInstance.initialize(starSelectorElement);
    });
  },
};
